import { uploadApi } from "@/shared/lib/upload-api";
import { uploadFileToPresignedUrl } from "@/shared/lib/upload-to-presigned";

function sanitizeFilename(name: string): string {
  return name.replace(/[^a-zA-Z0-9._-]/g, "_").slice(0, 100) || "file";
}

/**
 * Upload a single file via presigned PUT; returns the object key stored in DB.
 */
export async function presignUploadSingleFile(
  file: File,
  keyPrefix: string,
): Promise<string> {
  const ext = file.name.includes(".") ? (file.name.split(".").pop() ?? "") : "";
  const baseName = file.name.includes(".")
    ? file.name.slice(0, file.name.lastIndexOf("."))
    : file.name;
  const safeBase = sanitizeFilename(baseName);
  const key = `${keyPrefix}/${Date.now()}-${safeBase}${ext ? `.${ext}` : ""}`;
  const contentType = file.type || undefined;

  const { uploadUrl } = await uploadApi.getPresignUrl({
    key,
    contentType,
  });

  await uploadFileToPresignedUrl(uploadUrl, file, { contentType });
  return key;
}
